import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-company',
  templateUrl: './section-company.component.html',
  styleUrls: ['./section-company.component.scss']
})
export class SectionCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
